import React from 'react';
import OrdersTable from 'components/Table/Orders';
import {
  ordersModelReport,
  ordersItemsModelReportSlider,
} from 'components/Table/Orders/models';
import { Column } from 'components/Layout/Grid';
import OrderDropdown from 'components/OrderDropdown';

const ReportsSlider: React.FC = () => (
  <>
    <Column className="w-100 max-w-lg-100 flex-1 px-0">
      <OrdersTable
        trackingKey="Fichas e Laudos"
        tableSearchClassName="w-100"
        tabFilter={{ billingDate: { ne: null } }}
        model={ordersModelReport}
        pageSize={5}
        showButton={false}
        DropdownTemplate={(data: any) => (
          <OrderDropdown {...data} model={ordersItemsModelReportSlider} order={data} />
        )}
        customProps={{
          showOrderTrackingHistory: false,
          showOrderDownloadButtons: false,
        }}
        showFilter
        showTypeDateFilter
      />
    </Column>
  </>
);

export default ReportsSlider;
